import { trackEvent, EVENTS } from '../analytics';
import './SiteFooter.css';

export default function SiteFooter({ onOpenPrivacy }) {
  const year = new Date().getFullYear();

  const handlePrivacyClick = () => {
    trackEvent(EVENTS.CONTACT_LINK_CLICK, {
      link_type: 'privacy',
      link_text: 'privacy_policy',
      section_id: 'footer',
    });
    if (onOpenPrivacy) {
      onOpenPrivacy();
    }
  };

  return (
    <footer className="site-footer" data-analytics-ignore="true">
      <span className="site-footer__copy">&copy; {year} Myke Dixon</span>
      <button
        type="button"
        className="site-footer__privacy"
        data-analytics-id="footer_privacy"
        data-analytics-handled="true"
        onClick={handlePrivacyClick}
      >
        Privacy
      </button>
    </footer>
  );
}
